<div #rowLayout
     style="min-height: 100%; height: 100%; width: 100%; overflow: visible; user-select: none; padding-top: 16px;"
     appDragFileToBrowser [dragEnabled]="isExternalDragEnabled"  (filesList)="onFileDragToBrowser($event)"
     (click)="onDeadSpaceClick($event)"
     (contextmenu)="onDeadSpaceContext($event); false"
     data-cy="image-grid-container-div" >
  <div #gridRow
       *ngFor="let itemsRow of getItemsTable(rowLayout); index as i"
       cdkDropList [cdkDropListDisabled]="!isDragEnabled" [id]="'tdo-grid-drop-list-' + i"
       cdkDropListOrientation="horizontal"
       [cdkDropListData]="itemsRow"
       (cdkDropListDropped)="reorderDroppedItem($event)" style="display: flex; flex-wrap: wrap; overflow: visible; width: 100%;"
       data-cy="image-grid-row-div">

    <div *ngFor="let item of itemsRow" [cdkDragDisabled]="shouldDisableDrag()" cdkDrag [cdkDragData]="getItems(item)"
         [ngClass]="{'is-selected': isItemSelected(item)}"
         style="overflow: visible; border: 1px solid #555555; border-radius: var(--border-radius); margin-left: 4px; margin-right: 4px; margin-bottom: 4px; padding: 2px; font-size: 10px; color: white;"
         (click)="onClick($event, item, gridRow)"
         (dblclick)="onDoubleClick($event, item)"
         (contextmenu)="onContextMenu($event, item); false"
         (cdkDragExited)="onItemDragExited($event)"
         (cdkDragEntered)="onItemDragEntered($event)"
         (cdkDragStarted)="onItemDragStarted($event)"
         (cdkDragDropped)="onItemDragDropped($event)"
         (cdkDragMoved)="onItemDragMoved($event)"
         data-cy="image-grid-item-div"
    >
      <div *cdkDragPreview data-cy="image-grid-drag-preview-div">
        <div *ngIf="isGridDropList"
             [style.width]="boxWidth + 'px'"
             [style.height]="(boxWidth + this.descriptionHeight) + 'px'"
             style="padding: 8px;"
             class="image-grid-preview"
             data-cy="image-grid-grid-drop-list-preview-div">
          <img style="width: 100%;" [attr.src]="item.imageSource" [matTooltip]="getImageTooltip(item.model.dataDocument.DocumentID)" data-cy="image-grid-grid-drop-list-preview-image" >
        </div>
        <div *ngIf="!isGridDropList"
             style="padding: 8px; display: flex;"
             class="external-preview"
             data-cy="image-grid-external-preview-div">
          <img *ngIf="!isDocumentManagerMode" style="width: 100%; flex: 1;" [attr.src]="item.imageSource" [matTooltip]="getImageTooltip(item.model.dataDocument.DocumentID)" data-cy="image-grid-external-preview-image" >
          <mat-icon style="color: black; flex-basis: fit-content;" data-cy="image-grid-external-preview-icon">add_circle_outline</mat-icon>
        </div>
      </div>
      <div class="drag-placeholder" [style.height]="boxWidth" *cdkDragPlaceholder data-cy="image-grid-drag-placeholder-div"></div>
      <div #viewItem (mouseover)="onMouseOver($event, item, viewItem)" (mouseout)="onMouseOut($event, item)" class="item-box" style="position: relative;"
           [style.width]="boxWidth + 'px'"
           [style.height]="(boxWidth + this.descriptionHeight) + 'px'"
           data-cy="image-grid-view-item-div">
        <div *ngIf="isZoomEnabled && isMouseOver(item)" fxLayoutAlign="center center" class="item-box" style="position: absolute; z-index: 3000; pointer-events: none;"
             [style.left.px]="zoomLeft"
             [style.top.px]="zoomTop"
             [style.width]="400 + 'px'"
             [style.height]="400 + 'px'"
             data-cy="image-grid-zoom-item-div">
          <img *ngIf="!isDocumentManagerMode" style="border-top-left-radius: var(--border-radius); border-top-right-radius: var(--border-radius);" [matTooltip]="getImageTooltip(item.model.dataDocument.DocumentID)" [attr.src]="item.imageSource" data-cy="image-grid-zoom-item-image-document-manager-mode-false">
          <img *ngIf="isDocumentManagerMode" style="border-top-left-radius: var(--border-radius); border-top-right-radius: var(--border-radius);" [matTooltip]="getImageTooltip(item.model.dataDocument.DocumentID)" [attr.src]="item.imageSource" data-cy="image-grid-zoom-item-image-document-manager-mode-true">
        </div>
        <div [ngStyle]="{'height': boxWidth + 'px'}" class="image-box" data-cy="image-grid-image-box-div">
          <img *ngIf="!isDocumentManagerMode" style="border-top-left-radius: var(--border-radius); border-top-right-radius: var(--border-radius);" [attr.src]="item.imageSource" [matTooltip]="getImageTooltip(item.model.dataDocument.DocumentID)" loading="lazy" data-cy="image-grid-image-box-image-document-manager-mode-false">
          <img *ngIf="isDocumentManagerMode" style="border-top-left-radius: var(--border-radius); border-top-right-radius: var(--border-radius); " [attr.src]="item.imageSource" [matTooltip]="getImageTooltip(item.model.dataDocument.DocumentID)" loading="lazy" data-cy="image-grid-image-box-image-document-manager-mode-true" >
        </div>
        <mat-checkbox [disabled]="this.getDisabled(item.model.dataDocument.DocumentID)" [id]="item.model.dataDocument.DocumentID"
                      class="itemCheck" [checked]="isItemSelected(item)" (change)="onCheckboxChange($event, item)"
                      name="image-checkbox" [matTooltip]="getImageLabelTooltip(item.model.dataDocument.DocumentID)"
                      data-cy="image-grid-item-checkbox" >
          <span class="itemCheck-label" [innerHTML]="getImageLabel(item.model.dataDocument.DocumentID)" data-cy="image-grid-item-checkbox-label"></span>
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
